import { ITypedReduxAction } from '../../types/redux/actionType';
import { TSearchPromosResponse } from '../../types/searchResponse';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum EPaginationActionTypes {
  Request = 'PAGINATION/REQUEST',
  Success = 'PAGINATION/SUCCESS',
  Failure = 'PAGINATION/FAILURE',
}

export type TPaginationSuccess = ITypedReduxAction<EPaginationActionTypes.Success, TSearchPromosResponse>;
export type TPaginationRequest = ITypedReduxAction<EPaginationActionTypes.Request>;
export type TPaginationFailure = ITypedReduxAction<EPaginationActionTypes.Failure>;

/**
 * Redux action, который записывает в store список акций
 * @param promos TSearchPromosResponse
 */
export const paginationSuccess: (promos: TSearchPromosResponse) => TPaginationSuccess = actionGenerator<
  EPaginationActionTypes.Success,
  TSearchPromosResponse
>(EPaginationActionTypes.Success);

export const paginationRequest: () => TPaginationRequest = actionGenerator<EPaginationActionTypes.Request>(
  EPaginationActionTypes.Request,
);

export const paginationFailure: () => TPaginationFailure = actionGenerator<EPaginationActionTypes.Failure>(
  EPaginationActionTypes.Failure,
);

export type TPaginationActionTypes = TPaginationRequest | TPaginationSuccess | TPaginationFailure;
